import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../core/api.service';
import { endPoints } from '../core/Apis/apiEndpoints';
import { lastValueFrom } from 'rxjs';
import Swal from 'sweetalert2';

interface TierLevel {
  _id?: string;  // ← Add this
  from: number;
  to: number;
  label: string;
  createdAt?: string;
}

interface AppIndustryWithTiers {
  _id?: string;
  app_industry_id: string;
  app_industry_name: string;
  tier_levels: TierLevel[];
}

interface BackendAppIndustryItem {
  _id?: string;
  tier_levels: TierLevel[];
  app_industry: Array<{
    app_industry_id: string;
    app_industry_name: string;
  }>;
}
@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent implements OnInit {
  output1: any;
  userTypedropdown: any;
  creationForm: FormGroup;

  // stock department
  departments: any[] = [];
  filteredDepartments: any[] = [];
  searchTerm: string = '';

  // Customer Classification properties
  appIndustries: any[] = [];
  appIndustryTiers: AppIndustryWithTiers[] = [];
  showLinkDialog = false;
// temporaryEmployeeSearch = "";
newEmployeeSearch = "";
// temporaryEmployeeError = "";
newEmployeeError = "";
// temporaryEmployeeList: any = [];
newEmployeeList: any = [];
// isShownTempEmployee = false;
isShownNewEmployee = false;
// selectedTempEmployeeId = "";
selectedNewEmployeeId = "";
temporaryUserId = "";
  
// Validate tier progression (ignoring 0-0 values)
validateTierProgression(tiers: TierLevel[]): { isValid: boolean; message: string } {
  const sortedTiers = [...tiers].sort((a, b) => a.from - b.from);

  // Check for overlaps, but skip if the range is 0-0
  for (let i = 0; i < sortedTiers.length - 1; i++) {
    const currentTier = sortedTiers[i];
    const nextTier = sortedTiers[i + 1];

    // Skip comparison if both current and next tiers are 0-0
    if ((currentTier.from === 0 && currentTier.to === 0) || (nextTier.from === 0 && nextTier.to === 0)) {
      continue;
    }

    // Check if current tier's "to" value is >= next tier's "from"
    if (currentTier.to >= nextTier.from) {
      return {
        isValid: false,
        message: `"${currentTier.label}" range (${currentTier.from}-${currentTier.to}) overlaps with "${nextTier.label}" range (${nextTier.from}-${nextTier.to}).`
      };
    }
  }

  return { isValid: true, message: '' };
}



// Validate individual tier (from <= to)
validateTierRange(tier: TierLevel): { isValid: boolean; message: string } {
  if (tier.from < 0 || tier.to < 0) {
    return {
      isValid: false,
      message: `"${tier.label}" tier cannot have negative values`
    };
  }
  
  if (tier.from > tier.to) {
    return {
      isValid: false,
      message: `"${tier.label}" tier: "From" value (${tier.from}) cannot be greater than "To" value (${tier.to})`
    };
  }
  
  return { isValid: true, message: '' };
}

// Validate all tiers in an industry
validateIndustryTiers(industry: AppIndustryWithTiers): { isValid: boolean; message: string } {
  // First validate each tier individually
  for (const tier of industry.tier_levels) {
    const tierValidation = this.validateTierRange(tier);
    if (!tierValidation.isValid) {
      return tierValidation;
    }
  }
  
  // Then validate progression
  return this.validateTierProgression(industry.tier_levels);
}
  availableTierLabels = ['Diamond', 'Gold', 'Silver', 'Bronze'];
  
  searchIndustryTerm: string = '';
  filteredAppIndustryTiers: AppIndustryWithTiers[] = [];
  showEditModal: boolean = false;
  showCreateModal: boolean = false;
  editingIndustry: AppIndustryWithTiers | null = null;
  
  newIndustryId: string = '';
  newIndustryTiers: TierLevel[] = [];

  output: any = []; //---store get() result--------
  UserId = '';
  employee: any = [];

  ChangePasswordShown = false;
  SetPrivilegesShown = false;
  isShownEmployee = false;

  alert = '';
  isShown = false;

  listOut: any = [];
  empPrivilage: any = [];
  empPrivilage1: any = [];
  empPrivilage2: any = [];
  dummy: any = [];
  dummy1: any = [];
  dummyId: any = [];
  dummy1Id: any = [];
  count = 0;
  name = '';

  data = {
    new_password: '',
    conform_password: '',
  };

  data1 = {
    _id: '',
    new_password: '',
    user_type: '',
    user_id: '',
    check_out: '',
    check_in: '',
    temp_user_id: '',  
  new_user_id: ''
  };

  employee_name = '';
  password = '';
  conformpassword = '';
  doesntMatch = '';
  isChange = false;
  SucessMessage = '';

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });

  constructor(
    private employeeService: ServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService
  ) {
    this.creationForm = this.formBuilder.group({
      _id: [null, Validators.required],
      workin_time: [''],
      workout_time: [''],
       lunch_in_time: [''],
      lunch_out_time: [''],
      is_department_specific: [false],
      is_location_restricted: [false],
      weekly_working_days: [[]],
      factory_employee_id: [''],
      factory_department_id: [''],
      stock_department: [[]],
      app_industries: [[]],  // Added for customer classification
      sales_qualify_value: [0],
      visits_qualify_value: [0],
      visitplan_waiting_qualify_value: [0, [Validators.pattern('^[0-9]*$')]],
      visitplan_approval_qualify_value: [0, [Validators.pattern('^[0-9]*$')]],
      is_visit_location_restricted: [false],
      is_customer_location_enabled: [false],
      is_attendance_exempted: [false],
      has_visitplan_kpi: [false],
      has_kyc_update_permission: [false],
      on_department_warehouse: [false]
    });
  }

  // ---------- Helpers ----------
  private normalizeDepartments(raw: any[] = []) {
    return (raw || []).map(d => ({
      _id: d?.warehouse_id ?? d?._id ?? d?.id,
      warehouse_id: d?.warehouse_id ?? d?._id ?? d?.id,
      warehouse_name: d?.warehouse_name ?? d?.name ?? d?.department_name ?? 'Warehouse',
    }));
  }

  private isMongoId(v: any): boolean {
    return typeof v === 'string' && /^[a-f\d]{24}$/i.test(v);
  }

  private async fetchUserTypeWarehousesByName(userTypeName: string): Promise<string[]> {
    try {
      if (!userTypeName) return [];

      const match = (this.userTypedropdown || []).find((u: any) =>
        (u?.name || '').toLowerCase() === (userTypeName || '').toLowerCase()
      );
      if (!match?._id) return [];

      const svc: any = this.apiService as any;
      if (typeof svc.userTypedetails === 'function') {
        const details: any = await lastValueFrom(svc.userTypedetails(match._id));
        const type = details?.data?.[0];
        return Array.isArray(type?.warehouse_ids) ? type.warehouse_ids : [];
      }

      return [];
    } catch (e) {
      console.warn('Could not fetch user type warehouses', e);
      return [];
    }
  }

  // ---------- Lifecycle ----------
  ngOnInit(): void {
    this.resetAppIndustryTiers();
    this.filteredAppIndustryTiers = [...this.appIndustryTiers];

    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.UserId = params['id'];

        this.loadDepartments(async () => {
          this.loadAppIndustries(() => {
            this.fetchFactoryDepartment();
            this.getUsertype();
            this.getEditdata();
          });

          this.employeeService.ViewEmployeeById('/' + this.UserId).subscribe((res) => {
            this.output = res.data;
            this.name = this.output?.[0]?.employee_name || '';
          });
        });

      } else {
        alert('error User ID not found in query parameters');
      }
    });
  }

  loadDepartments(done?: () => void) {
    this.employeeService.Warehouse_Dropdown().subscribe({
      next: (res: any) => {
        const raw = res?.data || [];
        this.departments = this.normalizeDepartments(raw);
        this.filteredDepartments = [...this.departments];
        console.log('Stock Departments (Warehouses):', this.departments);
        if (done) done();
      },
      error: (err: any) => {
        console.error('Error fetching stock departments (warehouses):', err);
        if (done) done();
      }
    });
  }

  getUsertype() {
    this.employeeService.usertypeDropdown().subscribe((res) => {
      this.userTypedropdown = res.data;
    });
  }

  weeKDays = [
    { week: 'Sunday', value: 1, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
    { week: 'Monday', value: 2, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
    { week: 'Tuesday', value: 3, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
    { week: 'Wednesday', value: 4, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
    { week: 'Thursday', value: 5, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
    { week: 'Friday', value: 6, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
    { week: 'Saturday', value: 7, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' }
  ];

  selectedWeek: number[] = [];
  weekSelected(day: any) {
    day.checked = !day.checked;
    if (day.checked) {
      if (!this.selectedWeek.includes(day.value)) {
        this.selectedWeek.push(day.value);
      }
    } else {
      const index = this.selectedWeek.indexOf(day.value);
      if (index > -1) {
        this.selectedWeek.splice(index, 1);
      }
    }
    console.log(this.selectedWeek);
  }

  // Builds the weekly_time_schedule array from checked days for submission
  private buildWeeklyTimeSchedule() {
  return this.weeKDays
    .map(day => ({
      day: day.value,
      workin_time: day.workin_time || '',
      workout_time: day.workout_time || '',
      lunch_in_time: day.lunch_in_time || '',
      lunch_out_time: day.lunch_out_time || '',
      isActive: day.checked
    }));
}

  async getEditdata(): Promise<void> {
  // ✅ CRITICAL: Ensure appIndustries is loaded first
  if (!this.appIndustries || this.appIndustries.length === 0) {
    console.warn('⚠️ appIndustries not loaded yet, waiting...');
    await new Promise<void>((resolveIndustries) => {
      this.loadAppIndustries(() => {
        console.log('✅ appIndustries loaded:', this.appIndustries.length, 'industries');
        resolveIndustries();
      });
    });
  } else {
    console.log('✅ appIndustries already loaded:', this.appIndustries.length, 'industries');
  }
  
  await new Promise<void>((resolve) => {
    this.employeeService.UserPrivilege(this.UserId).subscribe({
      next: async (value) => {
        const user = value?.data?.[0] || {};

        // Warehouses handling
        const fromUser: string[] = Array.isArray(user?.warehouses)
          ? user.warehouses.map((w: any) => w?.warehouse_id).filter((id: any) => !!id)
          : [];

        let selectedIds: string[] = fromUser;
        if (!selectedIds.length) {
          const typeIds = await this.fetchUserTypeWarehousesByName(user?.user_type || '');
          selectedIds = Array.isArray(typeIds) ? typeIds : [];
        }

        const masterIds = new Set(this.departments.map((d: any) => String(d._id)));
        selectedIds.forEach((id) => {
          const sid = String(id);
          if (!masterIds.has(sid)) {
            this.departments.push({
              _id: sid,
              warehouse_id: sid,
              warehouse_name: `Custom Warehouse (${sid})`
            });
            masterIds.add(sid);
          }
        });

        this.departments = this.departments.map((d: any) => ({
          ...d,
          selected: selectedIds.includes(d._id) || selectedIds.includes(d.warehouse_id)
        }));

        // Patch form values
        this.creationForm.patchValue({
          _id: user._id,
          workin_time: user?.workin_time || '',
          workout_time: user?.workout_time || '',
          lunch_in_time: user?.lunch_in_time || '',
          lunch_out_time: user?.lunch_out_time || '',
          is_department_specific: user?.is_department_specific || false,
          is_location_restricted: user?.is_location_restricted || false,
          weekly_working_days: user?.weekly_working_days || [],
          factory_employee_id: user?.factory_employee_id || '',
          factory_department_id: user?.factory_department?.[0]?._id || '',
          sales_qualify_value: user?.sales_qualify_value ?? 0,
          visits_qualify_value: user?.visits_qualify_value ?? 0,
          visitplan_waiting_qualify_value: user?.visitplan_waiting_qualify_value ?? 0,
          visitplan_approval_qualify_value: user?.visitplan_approval_qualify_value ?? 0,
          is_visit_location_restricted: user?.is_visit_location_restricted || false,
          is_customer_location_enabled: user?.is_customer_location_enabled || false,
          is_attendance_exempted: user?.is_attendance_exempted || false,
          has_visitplan_kpi: user?.has_visitplan_kpi || false,
          has_kyc_update_permission: user?.has_kyc_update_permission || false,
          on_department_warehouse: user?.on_department_warehouse || false
        });

        this.creationForm.get('stock_department')?.setValue(selectedIds, { emitEvent: false });

        if (Array.isArray(user?.weekly_time_schedule)) {
          user.weekly_time_schedule.forEach((sched: any) => {
            const dayObj = this.weeKDays.find(
              d => d.value === sched.day
            );
            if (dayObj) {
              dayObj.workin_time = sched.workin_time || '';
              dayObj.workout_time = sched.workout_time || '';
              dayObj.lunch_in_time = sched.lunch_in_time || '';
              dayObj.lunch_out_time = sched.lunch_out_time || '';
              dayObj.checked = !!sched.isActive;
            }
          });
        }
        this.selectedWeek = this.weeKDays.filter(d => d.checked).map(d => d.value);

        // ✅ LOAD CUSTOMER CLASSIFICATION DATA - FIXED VERSION
        console.log('\n=== LOADING CUSTOMER CLASSIFICATION ===');

        // 🔥 CRITICAL FIX: Check app_industry array FIRST (latest data is here!)
        console.log('1. app_industry array (LATEST DATA):', user.app_industry);
        console.log('2. employee_app_industry (OLD DATA):', user.employee_app_industry);
        console.log('Available appIndustries dropdown:', this.appIndustries.length, 'items');

        // Clear existing data
        this.appIndustryTiers = [];
        const industryIds: string[] = [];

        // ✅ PRIORITY 1: Load from app_industry array (where submitAttendance() saves)
        let classificationData: any[] = [];

        // Check if app_industry exists and has data
        if (user.app_industry && Array.isArray(user.app_industry) && user.app_industry.length > 0) {
          console.log('🔥 LOADING FROM app_industry ARRAY - This has the latest data!');
          
          // Use app_industry data directly
          classificationData = user.app_industry.map((item: any, index: number) => {
            // Try to find corresponding _id from employee_app_industry if exists
            let classificationId = item._id;
            if (user.employee_app_industry && user.employee_app_industry[index]) {
              classificationId = user.employee_app_industry[index]._id || item._id;
            }
            
            return {
              _id: classificationId,
              app_industry_id: item.app_industry_id,
              app_industry_name: item.app_industry_name,
              tier_levels: item.tier_levels || []
            };
          });
        } 
        // ✅ PRIORITY 2: Load from employee_app_industry (legacy/backup)
        else if (user.employee_app_industry && Array.isArray(user.employee_app_industry) && user.employee_app_industry.length > 0) {
          console.log('📋 LOADING FROM employee_app_industry (backup)');
          
          classificationData = user.employee_app_industry.map((item: any) => {
            if (item.app_industry && Array.isArray(item.app_industry) && item.app_industry.length > 0) {
              return {
                _id: item._id,
                app_industry_id: item.app_industry[0].app_industry_id,
                app_industry_name: item.app_industry[0].app_industry_name,
                tier_levels: item.tier_levels || []
              };
            }
            return item;
          }).filter((item: any) => item.app_industry_id); // Filter out invalid items
        }

        if (classificationData.length > 0) {
          console.log(`Found ${classificationData.length} classification items`);
          
          classificationData.forEach((industryItem: any, itemIndex: number) => {
            console.log(`\n--- Processing industry item ${itemIndex + 1} ---`);
            
            // Process the standardized format
            if (industryItem.app_industry_id && industryItem.app_industry_name) {
              console.log(`  Processing industry: ${industryItem.app_industry_name} (ID: ${industryItem.app_industry_id})`);
              
              const matchedIndustry = this.appIndustries.find(
                ind => ind.app_industry_id === industryItem.app_industry_id
              );
              
              if (matchedIndustry) {
                console.log(`  ✅ FOUND matching industry in dropdown: ${matchedIndustry.app_industry_name}`);
                
                // Add to selected IDs
                industryIds.push(industryItem.app_industry_id);
                
                // Get tier levels directly from the item
                let tierLevels: TierLevel[] = [];
                if (industryItem.tier_levels && Array.isArray(industryItem.tier_levels) && industryItem.tier_levels.length > 0) {
                  tierLevels = industryItem.tier_levels.map((tier: any) => ({
                    _id: tier._id, // ← PRESERVE _id FROM BACKEND
                    from: tier.from ?? 0,
                    to: tier.to ?? 0,
                    label: tier.label,
                    createdAt: tier.createdAt // ← PRESERVE createdAt FROM BACKEND
                  }));
                  console.log(`  ✅ Loaded ${tierLevels.length} tiers from industry item`);
                  
                  // Debug: Show Platinum tier value
                  const platinumTier = tierLevels.find(t => t.label === 'Platinum');
                  if (platinumTier) {
                    console.log(`  🔍 Platinum tier: from=${platinumTier.from}, to=${platinumTier.to}, _id=${platinumTier._id}`);
                  }
                }
                
                // Ensure all 5 required tiers exist
                const requiredTiers = ['Diamond', 'Gold', 'Silver', 'Bronze'];
                const completeTiers = requiredTiers.map(tierLabel => {
                  const existing = tierLevels.find((t: TierLevel) => t.label === tierLabel);
                  if (existing) {
                    console.log(`    ✓ Tier ${tierLabel}: from=${existing.from}, to=${existing.to}, _id=${existing._id}`);
                    return existing;
                  } else {
                    console.log(`    + Creating default tier ${tierLabel}: from=0, to=0`);
                    return { from: 0, to: 0, label: tierLabel } as TierLevel;
                  }
                });
                
                // Add to appIndustryTiers array
                this.appIndustryTiers.push({
                  _id: industryItem._id, // Preserve _id
                  app_industry_id: industryItem.app_industry_id,
                  app_industry_name: industryItem.app_industry_name,
                  tier_levels: completeTiers
                });
                
                console.log(`  ✅ Added to appIndustryTiers with _id: ${industryItem._id || 'none'}`);
              } else {
                console.error(`  ❌ Industry NOT FOUND in dropdown!`);
                console.error(`  Looking for ID: ${industryItem.app_industry_id}`);
                console.error(`  Available IDs in dropdown:`, this.appIndustries.map(i => i.app_industry_id));
              }
            }
          });
        } else {
          console.log('❌ No classifications found');
        }

        console.log('\n=== FINAL RESULTS ===');
        console.log('✅ appIndustryTiers array:', this.appIndustryTiers.length, 'industries');

        // CRITICAL DEBUG: Show what value we loaded for Platinum tier
        if (this.appIndustryTiers.length > 0) {
          this.appIndustryTiers.forEach((industry, idx) => {
            const platinumTier = industry.tier_levels?.find(t => t.label === 'Platinum');
            if (platinumTier) {
              console.log(`📊 Industry ${idx + 1} (${industry.app_industry_name}) - Platinum: to=${platinumTier.to}`);
            }
          });
        }

        console.log('Details:', this.appIndustryTiers);
        console.log('✅ industryIds for form:', industryIds);
        console.log('=====================\n');

        // Update form control with selected industry IDs
        this.creationForm.patchValue({ app_industries: industryIds }, { emitEvent: false });

        // ✅ CRITICAL: Update the filtered display array
        this.filteredAppIndustryTiers = [...this.appIndustryTiers];
        console.log('✅ filteredAppIndustryTiers updated with', this.filteredAppIndustryTiers.length, 'industries\n');
        
        console.log('========================================\n');

        // Top card data
        this.output1 = value.data;
        this.data1.user_type = this.output1?.[0]?.user_type || '';
        this.data1._id = this.output1?.[0]?._id || '';
        this.data1.user_id = this.output1?.[0]?.user_id || '';
        if (this.output1?.[0]?.check_in) this.data1.check_in = this.output1[0].check_in.slice(0, -8);
        if (this.output1?.[0]?.check_out) this.data1.check_out = this.output1[0].check_out.slice(0, -8);
        this.employee_name = this.output1?.[0]?.user_fullname || '';
        this.data.new_password = this.output1?.[0]?.password || '';
        this.data.conform_password = this.output1?.[0]?.password || '';

        resolve();
      },
      error: (err) => {
        console.error('Error loading user data:', err);
        resolve();
      }
    });
  });
}
  factoryDepartmentdropdown: any = [];
  fetchFactoryDepartment() {
    this.apiService.get(endPoints.factoryDepartment, '/api/dropdown').subscribe({
      next: (value) => {
        this.factoryDepartmentdropdown = value.data;
      },
      error: (err) => {
        alert('error in fetching factory department');
        console.error(err);
      }
    });
  }

  // ---------- Customer Classification Methods ----------
  loadAppIndustries(callback?: () => void) {
    this.employeeService.getappIndustryDropdown().subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.appIndustries = res.data;
        } else {
          this.appIndustries = [];
        }
        if (callback) callback();
      },
      error: (err: any) => {
        this.appIndustries = [];
        if (callback) callback();
      },
    });
  }

  resetAppIndustryTiers() {
    this.appIndustryTiers = [];
  }

  openCreateModal() {
    this.newIndustryId = '';
    this.resetNewIndustryTiers();
    this.showCreateModal = true;
  }

  closeCreateModal() {
    this.showCreateModal = false;
    this.newIndustryId = '';
    this.resetNewIndustryTiers();
  }

  resetNewIndustryTiers() {
  this.newIndustryTiers = [
    { from: 0, to: 0, label: 'Diamond' },
    { from: 0, to: 0, label: 'Gold' },
    { from: 0, to: 0, label: 'Silver' },
    { from: 0, to: 0, label: 'Bronze' }
  ];
}

  // ============================================
// REPLACE YOUR EXISTING saveNewIndustryClassification() METHOD WITH THIS
// ============================================
saveNewIndustryClassification() {
  if (!this.newIndustryId) {
    this.Toast.fire({
      icon: 'error',
      title: 'Please select an industry'
    });
    return;
  }

  const industry = this.appIndustries.find(ind => ind.app_industry_id === this.newIndustryId);

  if (!industry) {
    this.Toast.fire({
      icon: 'error',
      title: 'Industry not found'
    });
    return;
  }

  const existingIndex = this.appIndustryTiers.findIndex(t => t.app_industry_id === this.newIndustryId);
  if (existingIndex !== -1) {
    this.appIndustryTiers.splice(existingIndex, 1); // Remove old industry
  }

  const tierLevels = this.newIndustryTiers.map((tier) => {
    const fromStr = String(tier.from);
    const toStr = String(tier.to);

    const fromValue = fromStr === '' || tier.from === null || tier.from === undefined ? 0 : Number(tier.from);
    const toValue = toStr === '' || tier.to === null || tier.to === undefined ? 0 : Number(tier.to);

    return {
      from: isNaN(fromValue) ? 0 : fromValue,
      to: isNaN(toValue) ? 0 : toValue,
      label: tier.label
    };
  });

  // CREATE NEW INDUSTRY ENTRY FOR VALIDATION
  const newIndustryEntry: AppIndustryWithTiers = {
    app_industry_id: this.newIndustryId,
    app_industry_name: industry.app_industry_name,
    tier_levels: tierLevels
  };

  // VALIDATE BEFORE SAVING
  const validation = this.validateIndustryTiers(newIndustryEntry);
  if (!validation.isValid) {
    Swal.fire({
      icon: 'error',
      title: 'Invalid Tier Configuration',
      text: validation.message,
      confirmButtonText: 'OK'
    });
    return;
  }

  // Add to local model (temporary front-end model)
  this.appIndustryTiers.push(newIndustryEntry);

  const current = this.creationForm.get('app_industries')?.value || [];
  if (!current.includes(this.newIndustryId)) {
    current.push(this.newIndustryId);
    this.creationForm.patchValue({ app_industries: current }, { emitEvent: false });
  }

  this.filterDisplayedIndustries();

  // Call saveToBackend to send data to the backend
  this.performSubmit();

  // Display success toast after data is added locally and saved
  this.Toast.fire({
    icon: 'success',
    title: 'Industry added to list and saved successfully'
  });

  // Close the modal after saving changes
  this.closeCreateModal();
}

// Replace your submitCustomerClassification() method with this:

// submitCustomerClassification() {
//   console.log('📋 Submitting Customer Classification...');

//   const selectedIndustryIds = this.creationForm.get('app_industries')?.value || [];
  
//   // ✅ ADD THIS: Get current form values for other fields
//   const form = this.creationForm.value;
//   const selectedWarehouseIds: string[] = (form.stock_department || []).map(String);
  
//   if (selectedIndustryIds.length === 0) {
//     Swal.fire({
//       title: 'Remove All Classifications?',
//       text: 'This will remove all customer classifications for this employee.',
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, remove all!'
//     }).then((result) => {
//       if (result.isConfirmed) {
//         this.performSubmit([], form, selectedWarehouseIds);
//       }
//     });
//     return;
//   }

//   this.performSubmit(selectedIndustryIds, form, selectedWarehouseIds);
// }

private performSubmit() {
  Swal.fire({
    title: 'Saving...',
    text: 'Please wait while we save your changes',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

  const form = this.creationForm.value;
  const selectedIds: string[] = (form.stock_department || []).map(String);
  const selectedIndustryIds = form.app_industries || [];

  const payload: any = {
    _id: form._id,
    workin_time: form.workin_time || '',
    workout_time: form.workout_time || '',
    lunch_in_time: form.lunch_in_time || '',
    lunch_out_time: form.lunch_out_time || '',
    is_department_specific: !!form.is_department_specific,
    is_location_restricted: !!form.is_location_restricted,
    weekly_working_days: Array.isArray(form.weekly_working_days) ? form.weekly_working_days : [],
    factory_employee_id: form.factory_employee_id || '',
    sales_qualify_value: form.sales_qualify_value ?? 0,
    visits_qualify_value: form.visits_qualify_value ?? 0,
    has_visitplan_kpi: !!form.has_visitplan_kpi,
    has_kyc_update_permission: !!form.has_kyc_update_permission,
    visitplan_waiting_qualify_value: form.visitplan_waiting_qualify_value ?? 0,
    visitplan_approval_qualify_value: form.visitplan_approval_qualify_value ?? 0,
    is_visit_location_restricted: !!form.is_visit_location_restricted,
    is_customer_location_enabled: !!form.is_customer_location_enabled,
    is_attendance_exempted: !!form.is_attendance_exempted,
    warehouse_ids: selectedIds,
    on_department_warehouse: !!form.on_department_warehouse,
    weekly_time_schedule: this.buildWeeklyTimeSchedule(),
    app_industry: this.appIndustryTiers.map((tierEntry) => ({
      app_industry_id: tierEntry.app_industry_id,
      app_industry_name: tierEntry.app_industry_name,
      tier_levels: tierEntry.tier_levels.map((tier: any) => ({
        from: Number(tier.from) || 0,
        to: Number(tier.to) || 0,
        label: tier.label
      }))
    }))
  };

  // Clean empty values
  Object.keys(payload).forEach(k => {
    const v = payload[k];
    if ((v === '' || v === null || v === undefined) && k !== 'factory_employee_id' && k !== 'warehouse_ids' && k !== 'app_industry') {
      delete payload[k];
    }
  });

  console.log("📤 FINAL PAYLOAD TO BACKEND:");
  console.log(JSON.stringify(payload, null, 2));

  this.employeeService.updateLoginuser(payload).subscribe(
    (res) => {
      Swal.close();
      if (res?.success) {
        this.Toast.fire({
          icon: 'success',
          title: 'Industry saved successfully!'
        });
      } else {
        this.Toast.fire({
          icon: 'error',
          title: 'Failed to save industry'
        });
      }
    },
    (err) => {
      Swal.close();
      this.Toast.fire({
        icon: 'error',
        title: 'Error: ' + (err?.message || 'Unknown error')
      });
    }
  );
}


 editIndustryClassification(industry: AppIndustryWithTiers) {
  console.log('📝 Editing industry:', industry.app_industry_name);
  console.log('Full industry data:', JSON.stringify(industry, null, 2));
  
  // ✅ Create a DEEP COPY to avoid reference issues
  this.editingIndustry = JSON.parse(JSON.stringify(industry));
  
  console.log('✅ editingIndustry set:', this.editingIndustry);
  this.showEditModal = true;
}

  closeEditModal() {
    this.showEditModal = false;
    this.editingIndustry = null;
  }

  saveEditedClassification() {
  if (!this.editingIndustry) {
    return;
  }
  
  console.log('💾 Saving edited industry:', this.editingIndustry.app_industry_name);
  console.log('📋 Current editing data:', JSON.stringify(this.editingIndustry, null, 2));
  
  // ✅ Validate before saving
  const validation = this.validateIndustryTiers(this.editingIndustry);
  if (!validation.isValid) {
    Swal.fire({
      icon: 'error',
      title: 'Invalid Tier Configuration',
      text: validation.message,
      confirmButtonText: 'OK'
    });
    return;
  }
  
  const index = this.appIndustryTiers.findIndex(
    ind => ind.app_industry_id === this.editingIndustry!.app_industry_id
  );
  
  if (index === -1) {
    this.Toast.fire({
      icon: 'error',
      title: 'Industry not found in list'
    });
    return;
  }
  
  // ✅ Preserve the _id from the existing item
  const existingItem = this.appIndustryTiers[index];
  
  // ✅ Build updated industry
  const updatedIndustry: AppIndustryWithTiers = {
    app_industry_id: this.editingIndustry.app_industry_id,
    app_industry_name: this.editingIndustry.app_industry_name,
    tier_levels: this.editingIndustry.tier_levels.map((tier: TierLevel) => {
      const updatedTier: TierLevel = {
        from: Number(tier.from) || 0,
        to: Number(tier.to) || 0,
        label: tier.label
      };
      
      // ✅ Preserve tier _id if it exists
      if (tier._id) {
        updatedTier._id = tier._id;
      }
      
      // ✅ Preserve createdAt if it exists
      if (tier.createdAt) {
        updatedTier.createdAt = tier.createdAt;
      }
      
      return updatedTier;
    })
  };
  
  // ✅ CRITICAL: Preserve the classification _id
  if (existingItem._id) {
    updatedIndustry._id = existingItem._id;
  }
  
  console.log('✅ Updated industry to save:', JSON.stringify(updatedIndustry, null, 2));
  
  // Update main array
  this.appIndustryTiers[index] = updatedIndustry;
  
  // Force change detection
  this.appIndustryTiers = [...this.appIndustryTiers];
  this.filteredAppIndustryTiers = [...this.appIndustryTiers];
  
  console.log('✅ appIndustryTiers after update:', JSON.stringify(this.appIndustryTiers, null, 2));
  
  this.Toast.fire({
    icon: 'success',
    title: 'Changes saved! Click "Submit" to persist to database.'
  });
  
  this.submitAttendance();
  this.closeEditModal();
}


  removeIndustryFromListing(industryId: string) {
  Swal.fire({
    title: 'Are you sure?',
    text: 'This will remove the industry from the list. Click "Save Classifications" to persist changes.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, remove it!'
  }).then((result) => {
    if (result.isConfirmed) {
      console.log('🗑️ Removing industry:', industryId);
      
      // ✅ Remove from in-memory arrays
      this.appIndustryTiers = this.appIndustryTiers.filter(
        ind => ind.app_industry_id !== industryId
      );
      
      // ✅ Update form control to reflect the removal
      const currentFormValue = this.creationForm.get('app_industries')?.value || [];
      const updatedFormValue = currentFormValue.filter((id: string) => id !== industryId);
      this.creationForm.patchValue({ app_industries: updatedFormValue }, { emitEvent: false });
      
      // ✅ Update filtered display list
      this.filteredAppIndustryTiers = [...this.appIndustryTiers];
      
      // Show success message
      this.Toast.fire({
        icon: 'success',
        title: 'Industry removed! Click "Save Classifications" to persist.'
      });

      // ✅ Immediately call submitAttendance to save the changes
      this.submitAttendance();
    }
  });
}


  filterDisplayedIndustries() {
  console.log('🔍 Filtering industries, search term:', this.searchIndustryTerm);
  console.log('Total industries:', this.appIndustryTiers.length);
  
  if (!this.searchIndustryTerm || this.searchIndustryTerm.trim() === '') {
    // ✅ Show ALL industries
    this.filteredAppIndustryTiers = [...this.appIndustryTiers];
  } else {
    // ✅ Filter by search term
    const searchLower = this.searchIndustryTerm.toLowerCase();
    this.filteredAppIndustryTiers = this.appIndustryTiers.filter(industry =>
      industry.app_industry_name.toLowerCase().includes(searchLower)
    );
  }
  
  console.log('Filtered to', this.filteredAppIndustryTiers.length, 'industries');
}
  getTotalTiersCount(): number {
    return this.appIndustryTiers.reduce((total, industry) => {
      return total + (industry.tier_levels?.length || 0);
    }, 0);
  }

  getTierBadgeClass(label: string): string {
  const badgeClasses: { [key: string]: string } = {
    'Diamond': 'badge-diamond',
    'Gold': 'badge-gold',
    'Silver': 'badge-silver',
    'Bronze': 'badge-bronze'
  };
  return badgeClasses[label] || 'badge-secondary';
}

  getTierIconClass(label: string): string {
  const iconClasses: { [key: string]: string } = {
    'Diamond': 'fas fa-gem',
    'Gold': 'fas fa-award',
    'Silver': 'fas fa-certificate',
    'Bronze': 'fas fa-medal'
  };
  return iconClasses[label] || 'fas fa-star';
}


 onTierValueChange(industryId: string, tierIndex: number, property: 'from' | 'to', event: any) {
  if (this.editingIndustry && this.editingIndustry.app_industry_id === industryId) {
    const numValue = Number(event) || 0;
    
    // ✅ Update the value directly
    this.editingIndustry.tier_levels[tierIndex][property] = numValue;
    
    // ✅ Create a DEEP copy to trigger change detection
    this.editingIndustry = {
      ...this.editingIndustry,
      tier_levels: [...this.editingIndustry.tier_levels]
    };
    
    console.log(`✅ Updated ${property} for tier ${tierIndex}: ${numValue}`);
  }
}

  // ---------- Password / Privileges (unchanged logic) ----------
  shown() {
    this.isShown = false;
  }

  valuechange2(newValue1: any) {
    this.data.new_password = newValue1;
    this.password = '';
  }

  valuechange3(newValue1: any) {
    this.data.conform_password = newValue1;
    this.conformpassword = '';
    this.doesntMatch = '';
  }

  PasswordChange() {
    this.password = '';
    this.conformpassword = '';
    this.doesntMatch = '';
    this.isChange = false;

    if ((!this.data.new_password || this.data.new_password.trim() === '') && 
        (!this.data.conform_password || this.data.conform_password.trim() === '')) {
      this.prepareAndSubmitData(false);
      return;
    }

    if (!this.data.new_password || this.data.new_password.trim() === '') {
      this.password = 'Enter password';
      return;
    }

    if (!this.data.conform_password || this.data.conform_password.trim() === '') {
      this.conformpassword = 'Enter confirm password';
      return;
    }

    if (this.data.new_password !== this.data.conform_password) {
      this.doesntMatch = "Passwords don't match";
      return;
    }

    this.prepareAndSubmitData(true);
  }

  private prepareAndSubmitData(shouldChangePassword: boolean) {
    this.data1.new_password = shouldChangePassword ? this.data.new_password : '';
    
    const payload: any = {
      _id: this.data1._id,
      user_type: this.data1.user_type,
      user_id: this.data1.user_id,
      check_out: this.data1.check_out,
      check_in: this.data1.check_in
    };

    if (shouldChangePassword && this.data1.new_password) {
      payload.new_password = this.data1.new_password;
    }

    this.employeeService.PasswordReset(payload).subscribe((res) => {
      this.alert = res.message;
      this.isChange = true;
      
      if (shouldChangePassword) {
        this.data.new_password = '';
        this.data.conform_password = '';
      }
    });
  }

  SearchEmployee() {
    if (this.employee_name != '') {
      this.isShownEmployee = true;
    }
    this.employeeService.SearchEmployee(this.employee_name).subscribe((res) => {
      this.employee = res.data;
    });
  }

  valuechange5(newValue1: any) {
    this.data1.user_type = newValue1;
  }

  valuechange4(newValue1: any) {
    this.employee_name = newValue1;
  }

  getEmployeeId(value1: any, value2: any) {
    this.isShownEmployee = false;
    this.employee_name = value2;
    this.data1.user_id = value1;
  }

  ChangePassword() {
    this.ChangePasswordShown = true;
    this.SetPrivilegesShown = false;
  }

  SetPrivilege() {
    this.SetPrivilegesShown = true;
    this.ChangePasswordShown = false;

    this.employeeService.ViewPrivileges().subscribe((res) => {
      this.listOut = res.data;
      for (let i = 0; i < this.listOut.length; i++) {
        this.dummy[i] = this.listOut[i].privilege_name;
        this.dummyId = this.listOut[i]._id;
      }
    });

    this.dummy1 = this.dummy;
    this.dummy1Id = this.dummyId;

    this.employeeService.UserPrivilege(this.UserId).subscribe((res) => {
      this.empPrivilage = res.data?.[0]?.user_privilege?.[0]?.split(',') || [];
      if (this.empPrivilage[0] == '') {
        this.empPrivilage.shift();
      }
      this.empPrivilage1 = this.empPrivilage;
      this.empPrivilage2 = this.empPrivilage;
    });
  }

  AddPrivileges() {
    this.empPrivilage = this.empPrivilage2.concat(this.dummy1);
    this.dummy = [];
  }

  RemovePrivileges() {
    this.empPrivilage = this.empPrivilage1;
    this.dummy = this.dummy1;
  }

  AddItem = (item: string) => {
    this.empPrivilage = this.empPrivilage.concat(item);
    this.dummy = this.dummy.filter((value: any) => value !== item);
  };

  RemoveItem = (item: string) => {
    this.dummy = this.dummy.concat(item);
    this.empPrivilage = this.empPrivilage.filter((value: any) => value !== item);
  };

  AddNewPrivileges() {
    const privileges = new URLSearchParams();
    privileges.set('user_id', this.UserId);
    privileges.set('privilege_name', this.empPrivilage as any);

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    this.employeeService.postPrivileges(privileges, options).subscribe((res: any) => {
      this.SucessMessage = res.message;
      setTimeout(() => {
        this.SucessMessage = '';
      }, 2000);
    });
  }

  addWorkingDays(Id: any) {
    this.router.navigate(['admin/user-working-days-list'], { queryParams: { setData: JSON.stringify({ Id }) } });
  }

 
submitAttendance() {
  // Validate form
  if (!this.creationForm.valid) {
    this.employeeService.showToast('error', 'Invalid Form');
    console.log('Form Errors:', this.creationForm.errors);
    return;
  }

  const weekdayValidation = this.validateWeekdayTimes();
  if (!weekdayValidation.isValid) {
    Swal.fire({
      icon: 'error',
      title: 'Missing Time Fields',
      text: weekdayValidation.message,
      confirmButtonText: 'OK'
    });
    return;
  }

  try {
    // Prepare form data
    this.creationForm.patchValue({ weekly_working_days: this.selectedWeek });
    const selectedIds: string[] = (this.creationForm.value.stock_department || []).map(String);
    const selectedIndustryIds = this.creationForm.get('app_industries')?.value || [];
    const form = this.creationForm.value;

    console.log('=== SUBMIT DEBUG ===');
    console.log('Selected Industry IDs from form:', selectedIndustryIds);
    console.log('appIndustryTiers array:', this.appIndustryTiers);

    let hasValidationErrors = false;
    let validationErrorMessage = '';

    for (const industry of this.appIndustryTiers.filter(tierEntry => 
      selectedIndustryIds.includes(tierEntry.app_industry_id))) {
      
      const validation = this.validateIndustryTiers(industry);
      if (!validation.isValid) {
        hasValidationErrors = true;
        validationErrorMessage = `Validation Error in ${industry.app_industry_name}: ${validation.message}`;
        break;
      }
    }

    if (hasValidationErrors) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Tier Configuration',
        text: validationErrorMessage,
        confirmButtonText: 'OK'
      });
      return;
    }

    // ✅ BUILD app_industry IN THE EXACT FORMAT YOU SHOWED
    const appIndustryData = this.appIndustryTiers
      .filter(tierEntry => selectedIndustryIds.includes(tierEntry.app_industry_id))
      .map(tierEntry => ({
        app_industry_id: tierEntry.app_industry_id,
        app_industry_name: tierEntry.app_industry_name,
        tier_levels: tierEntry.tier_levels.map((tier: any) => ({
          from: Number(tier.from) || 0,
          to: Number(tier.to) || 0,
          label: tier.label
          // ❌ DON'T send _id or createdAt - backend will handle these
        }))
      }));

    console.log('Filtered appIndustryData to send:', appIndustryData);

    // ✅ BUILD COMPLETE PAYLOAD - MATCH YOUR EXACT REQUEST BODY FORMAT
    const payload: any = {
      _id: form._id,
      workin_time: form.workin_time || '',
      workout_time: form.workout_time || '',
      lunch_in_time: form.lunch_in_time || '',
      lunch_out_time: form.lunch_out_time || '',
      is_department_specific: !!form.is_department_specific,
      is_location_restricted: !!form.is_location_restricted,
      weekly_working_days: Array.isArray(form.weekly_working_days) ? form.weekly_working_days : [],
      factory_employee_id: form.factory_employee_id || '',
      sales_qualify_value: form.sales_qualify_value ?? 0,
      visits_qualify_value: form.visits_qualify_value ?? 0,
      has_visitplan_kpi: !!form.has_visitplan_kpi,
      has_kyc_update_permission: !!form.has_kyc_update_permission,
      visitplan_waiting_qualify_value: form.visitplan_waiting_qualify_value ?? 0,
      visitplan_approval_qualify_value: form.visitplan_approval_qualify_value ?? 0,
      is_visit_location_restricted: !!form.is_visit_location_restricted,
      is_customer_location_enabled: !!form.is_customer_location_enabled,
      is_attendance_exempted: !!form.is_attendance_exempted,
      warehouse_ids: selectedIds,
      on_department_warehouse: !!form.on_department_warehouse,
      weekly_time_schedule: this.buildWeeklyTimeSchedule(),
      app_industry: appIndustryData,  // ✅ SIMPLE FORMAT - NO NESTING
      user_type: this.data1.user_type || 'BDM'
    };

    // Add optional fields if present
    if (form.factory_department_id && this.isMongoId(form.factory_department_id)) {
      payload.factory_department_id = form.factory_department_id;
    }

    // Clean empty values (except important ones)
    Object.keys(payload).forEach(k => {
      const v = payload[k];
      if (
        (v === '' || v === null || v === undefined) &&
        k !== 'factory_employee_id' &&
        k !== 'warehouse_ids' &&
        k !== 'app_industry'
      ) {
        delete payload[k];
      }
    });

    // Log for debugging
    console.log('📤 === FINAL PAYLOAD TO BACKEND ===');
    console.log(JSON.stringify(payload, null, 2));
    console.log('app_industry count:', payload.app_industry?.length || 0);

    // Show loading
    Swal.fire({
      title: 'Saving...',
      text: 'Please wait while we save your changes',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    // Make API call
    this.employeeService.updateLoginuser(payload).subscribe({
      next: (res) => {
        console.log('✅ === BACKEND RESPONSE ===');
        console.log('Full response:', res);
        console.log('Success:', res?.success);
        console.log('Message:', res?.message);
        
        Swal.close();
        
        if (res?.success === true || res?.success === 'true') {
          this.employeeService.showToast('success', 'All settings saved successfully!');
          
          // ✅ DON'T RELOAD - Keep the UI state as is
          console.log('✅ Save complete - UI already has correct data');
          console.log('Current appIndustryTiers:', this.appIndustryTiers);
          
        } else {
          console.error('❌ Backend returned success=false');
          this.employeeService.showToast('error', res?.message || 'Update failed');
        }
      },
      error: (err) => {
        Swal.close();
        
        console.error('❌ === API ERROR ===');
        console.error('Error object:', err);
        console.error('Status:', err.status);
        console.error('Error message:', err.error);
        
        let errorMessage = 'Server or Network Error';
        
        if (err.error?.message) {
          errorMessage = err.error.message;
        } else if (err.message) {
          errorMessage = err.message;
        }
        
        this.employeeService.showToast('error', errorMessage);
      }
    });

  } catch (error) {
    console.error('❌ UNEXPECTED ERROR:', error);
    this.employeeService.showToast('error', 'Unexpected error: ' + (error as any).message);
  }
}

// Open Link Dialog
openLinkDialog() {
  console.log("🔵 Opening link dialog");
  
  // Get the user_id from the response data
  if (this.output1 && this.output1[0] && this.output1[0].user_id) {
    this.temporaryUserId = this.output1[0].user_id;
    console.log("Auto-filled temporary_employee_id:", this.temporaryUserId);
  } else {
    console.error("No user_id found in output1");
    this.employeeService.showToast('error', 'Unable to get temporary user ID');
    return;
  }
  
  this.showLinkDialog = true;
  this.newEmployeeSearch = "";
  this.newEmployeeError = "";
  this.selectedNewEmployeeId = "";
}

// Close Link Dialog
closeLinkDialog() {
  this.showLinkDialog = false;
  // this.isShownTempEmployee = false;
  this.isShownNewEmployee = false;
}

// Search Temporary Employee
// searchTemporaryEmployee() {
//   if (this.temporaryEmployeeSearch && this.temporaryEmployeeSearch.trim() !== '') {
//     this.isShownTempEmployee = true;
//     this.employeeService.ViewAllEmployeefilter("?employee_name=" + this.temporaryEmployeeSearch).subscribe((res) => {
//       this.temporaryEmployeeList = res.data;
//     });
//   } else {
//     this.isShownTempEmployee = false;
//   }
// }

// Search New Employee
searchNewEmployee() {
  if (this.newEmployeeSearch && this.newEmployeeSearch.trim() !== '') {
    this.isShownNewEmployee = true;
    this.employeeService.ViewAllEmployeefilter("?employee_name=" + this.newEmployeeSearch).subscribe((res) => {
      this.newEmployeeList = res.data;
    });
  } else {
    this.isShownNewEmployee = false;
  }
}

// Select Temporary Employee
// selectTemporaryEmployee(employeeId: string, employeeName: string) {
//   this.isShownTempEmployee = false;
//   this.temporaryEmployeeSearch = employeeName;
//   this.selectedTempEmployeeId = employeeId;
//   this.temporaryEmployeeError = "";
// }

// Select New Employee
selectNewEmployee(employeeId: string, employeeName: string) {
  this.isShownNewEmployee = false;
  this.newEmployeeSearch = employeeName;
  this.selectedNewEmployeeId = employeeId;
  this.newEmployeeError = "";
}

// Submit Link
submitLink() {
  // Validation - only check new employee
  if (!this.selectedNewEmployeeId) {
    this.newEmployeeError = "Please select a new employee";
    return;
  }

  const requestBody = {
    temporary_employee_id: this.temporaryUserId,  // Auto-filled from response
    new_employee_id: this.selectedNewEmployeeId    // Selected from dropdown
  };

  console.log("Link Request Body:", requestBody);

  this.employeeService.linkTemporaryEmployee(requestBody).subscribe({
    next: (res: any) => {
      if (res.success) {
        this.employeeService.showToast('success', res.message || 'Employees linked successfully!');
        this.closeLinkDialog();
      } else {
        this.employeeService.showToast('error', res.message || 'Failed to link employees');
      }
    },
    error: (err) => {
      console.error('Error:', err);
      this.employeeService.showToast('error', 'An error occurred. Please try again.');
    }
  });
}
private validateWeekdayTimes(): { isValid: boolean; message: string } {
    for (const day of this.weeKDays) {
      if (day.checked) {
        if (!day.workin_time || !day.workout_time || !day.lunch_in_time || !day.lunch_out_time) {
          return {
            isValid: false,
            message: `Please fill all time fields (Work in, Work out, Lunch in, Lunch out) for ${day.week}.`
          };
        }
      }
    }
    return { isValid: true, message: '' };
  }
  fillAllTimes() {
  const sourceDay = this.weeKDays.find(
    d => d.checked && (d.workin_time || d.workout_time || d.lunch_in_time || d.lunch_out_time)
  );

  if (!sourceDay) {
    Swal.fire({
      icon: 'warning',
      title: 'Nothing to copy',
      text: 'Fill the time fields for at least one selected day first.'
    });
    return;
  }

  this.weeKDays.forEach(day => {
    if (day.checked) {
      day.workin_time = sourceDay.workin_time;
      day.workout_time = sourceDay.workout_time;
      day.lunch_in_time = sourceDay.lunch_in_time;
      day.lunch_out_time = sourceDay.lunch_out_time;
    }
  });

  this.Toast.fire({
    icon: 'success',
    title: 'Times applied to all selected days'
  });
}
}